// extracted by mini-css-extract-plugin
export var title = "Input-module--title--17aRy";
export var lightTitle = "Input-module--light-title--FMtT9";
export var errorText = "Input-module--errorText--22iM8";
export var darkInput = "Input-module--darkInput--19m97";
export var lightInput = "Input-module--lightInput--3AI-M";
export var error = "Input-module--error--2jNiL";
export var required = "Input-module--required--2SLlv";